import {
  startOfMonth,
  endOfMonth,
  subMonths,
  format,
  differenceInCalendarDays,
  subDays,
  isSameMonth,
} from 'date-fns'

const LAST_7_DAYS = 'last-7'
const LAST_30_DAYS = 'last-30'
const MONTHS_TO_SHOW = 12

export type TReportDateRange = {
  startDate: string
  endDate: string
  periodDays: number
}

export type TReportDateOption = {
  key: string
  label: string
  value: string
}

export const DEFAULT_REPORT_DATE_VALUE = LAST_30_DAYS

function formatDate(date: Date): string {
  return format(date, 'yyyy-MM-dd')
}

export function getReportDateOptions(): TReportDateOption[] {
  const today = new Date()
  const options: TReportDateOption[] = [
    { key: LAST_7_DAYS, label: 'Last 7 days', value: LAST_7_DAYS },
    { key: LAST_30_DAYS, label: 'Last 30 days', value: LAST_30_DAYS },
  ]

  for (let i = 0; i < MONTHS_TO_SHOW; i += 1) {
    const monthDate = subMonths(today, i)
    const monthKey = format(monthDate, 'yyyy-MM')
    const isCurrentMonth = isSameMonth(monthDate, today)
    const monthLabel = isCurrentMonth
      ? `${format(monthDate, 'MMMM yyyy')} (to date)`
      : format(monthDate, 'MMMM yyyy')

    options.push({ key: monthKey, label: monthLabel, value: monthKey })
  }

  return options
}

export function getDateRangeFromSelection(value: string): TReportDateRange {
  const today = new Date()

  if (value === LAST_7_DAYS) {
    const start = subDays(today, 6)
    return {
      startDate: formatDate(start),
      endDate: formatDate(today),
      periodDays: 7,
    }
  }

  if (value === LAST_30_DAYS) {
    const start = subDays(today, 29)
    return {
      startDate: formatDate(start),
      endDate: formatDate(today),
      periodDays: 30,
    }
  }

  const [year, month] = value.split('-').map(Number)
  const monthDate = new Date(year, month - 1, 1)
  const start = startOfMonth(monthDate)
  const isCurrentMonth = isSameMonth(monthDate, today)
  const end = isCurrentMonth ? today : endOfMonth(monthDate)
  const days = differenceInCalendarDays(end, start) + 1

  return {
    startDate: formatDate(start),
    endDate: formatDate(end),
    periodDays: days,
  }
}
